import styled from "styled-components";

export const BarChartWrapper = styled.div`
  min-width: 40vw;
`;

export const PieChartWrapper = styled.div`
  min-width: 30vw;
`;
